import React, {useEffect, useState} from 'react'
import {Button, Stack, TextField} from "@mui/material"
import ContentCopyIcon from "@mui/icons-material/ContentCopy"
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"
import ModalBase from "../modal/ModalBase"
import InfoAlert from "../alert/InfoAlert"
import {CreatedApiKeyJson} from "../../api/json/ApiKeyJson"

interface ApiKeyRevealModalProps {
    createdKey: CreatedApiKeyJson | null
    open: boolean
    setOpen: (open: boolean) => void
}

function ApiKeyRevealModal({createdKey, open, setOpen}: ApiKeyRevealModalProps) {
    const [copied, setCopied] = useState(false)

    useEffect(() => setCopied(false), [createdKey])

    const key = createdKey?.key ?? ""

    return (
        <ModalBase open={open}
                   setOpen={setOpen}
                   title="API key created"
                   blockBackdropClick
                   buttons={<Button variant="contained" onClick={() => setOpen(false)}>Done</Button>}>
            <Stack spacing={2}>
                <InfoAlert>
                    Copy this key now — you won't be able to see it again.
                </InfoAlert>
                <Stack direction="row" spacing={1} alignItems="center">
                    <TextField value={key}
                               InputProps={{readOnly: true}}
                               fullWidth
                               size="small"
                               sx={{fontFamily: "monospace"}}
                               onClick={(event) => (event.target as HTMLInputElement).select()}/>
                    <Button endIcon={copied ? <CheckCircleOutlineIcon/> : <ContentCopyIcon/>}
                            onClick={() => navigator.clipboard.writeText(key).then(() => setCopied(true))}>
                        {copied ? "Copied" : "Copy"}
                    </Button>
                </Stack>
            </Stack>
        </ModalBase>
    )
}

export default ApiKeyRevealModal
